"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ProgressCircle_label_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCircle = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const progress_circle_styles_1 = require("./progress-circle-styles");
let ProgressCircle = class ProgressCircle extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _ProgressCircle_label_accessor_storage.set(this, 'Loading...');
    }
    get label() { return __classPrivateFieldGet(this, _ProgressCircle_label_accessor_storage, "f"); }
    set label(value) { __classPrivateFieldSet(this, _ProgressCircle_label_accessor_storage, value, "f"); }
    render() {
        return (0, lit_1.html) `
            <div class="circular-progress-container">
                <forge-circular-progress aria-label="Circular Progress" role="progressbar"></forge-circular-progress>
                <forge-label class="circular-progress-label">${this.label}</forge-label>
            </div>
        `;
    }
};
exports.ProgressCircle = ProgressCircle;
_ProgressCircle_label_accessor_storage = new WeakMap();
Object.defineProperty(ProgressCircle, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        progress_circle_styles_1.progressCircleComponentStyles
    ]
});
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProgressCircle.prototype, "label", null);
exports.ProgressCircle = ProgressCircle = __decorate([
    (0, decorators_js_1.customElement)("sup-progress-circle")
], ProgressCircle);
